import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';

export const taskDetailsQueryKey = (taskId: string | number) => ['task-details', taskId.toString()];

export const useGraphneTaskDetails = (taskId: string) => {
  const graphneAPI = useGraphneAPI();

  return useQuery({
    queryKey: taskDetailsQueryKey(taskId),
    queryFn: () => graphneAPI.getGraphneTasksTaskid({ taskId }),
    enabled: !!taskId,
  });
};

export const useGraphneTaskDetailsSuspense = (taskId: string) => {
  const graphneAPI = useGraphneAPI();

  return useSuspenseQuery({
    queryKey: taskDetailsQueryKey(taskId),
    queryFn: () => graphneAPI.getGraphneTasksTaskid({ taskId }),
  });
};
